<app-set-weight-modal [job]='this.currentJob'></app-set-weight-modal>
<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Weighbridge</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/weighbridge/yard-trade/list'><i class="fas fa-plus"></i> Yard trade</button>&nbsp;
    </div>
  </div>
  <br />
  <br />

  <div class='sheet'>
    <h1 class='header'>Tip site</h1>
    <div class='form-row'>
      <div class='form-group col-md-8'>
        <select class='form-control' (change)='onTipChanged($event)'>
          <option>Please select a tip for weighbridge</option>
          @for (tip of this.tips; track tip) {
            <option [value]='tip.id' [selected]='this.defaultTip === tip.id'>{{ tip.name }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <br />
  <br />
  @if (this.tipId !== -1) {
    <app-grid
      entity='job'
      [filters]='this.filters'
      [columns]='this.columns'
      [buttons]='this.buttons'
      [showDatePicker]='true'
      [displayDate]='this.displayDate'
      [searchFilters]='this.searchFilters'
      [searchFields]='this.searchFields'
      [relationships]='["jobAssignment", "jobAssignment.driver", "jobAssignment.vehicle", "jobAssignment.subcontractor"]'
    ></app-grid>
  }
</div>
